import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import FirebaseAuth from '../containers/FirebaseAuthContainer';
import { handleFieldChange } from '../../../helpers/ReactUtils';
import { showError } from '../../../common/A1Alert/A1Alert';
import ShowPassword from '../../../common/showPassword/ShowPassword';

export class LoginComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
        };
    }

    _onSubmit = (e) => {
        e.preventDefault();

        if (this.props.firebasePopupOpen) {
            // This can only happen if the user filled the form and afterwards clicks on a social login and then clicks the submit button
            return showError('A autenticação já foi iniciada. Por favor, finalize o processo na outra janela.');
        }

        const { email, password } = this.state;

        if (isEmpty(email) || isEmpty(password)) {
            showError('Insere o seu email e a sua senha para fazer o login!');

            return false;
        }

        return this.props.login(email, password);
    };

    render() {
        const { email, password } = this.state;
        const { submitting } = this.props;

        return (
            <section className="sectionLogin">
                <h2>Faça o login para acessar o site</h2>
                <form className="loginForm" onSubmit={this._onSubmit}>
                    <div className="containerEmail">
                        <label htmlFor="email">E-mail</label>
                        <input type="email" name="email" id="email" value={email} onChange={handleFieldChange(this)} required autoComplete="email" autoCapitalize="off" autoCorrect="off" />
                    </div>
                    <div className="containerPassword">
                        <ShowPassword
                            name="password"
                            id="password"
                            label="Senha"
                            value={password}
                            onChange={handleFieldChange(this)}
                            required
                        />
                    </div>
                    <div className="submitLogin">
                        <button type="submit" className="cta" disabled={!!submitting}>
                            {submitting === 'login' ? 'Entrando...' : 'Entrar'}
                        </button>
                    </div>
                </form>

                <Button className="tw-m-auto tw-text-center tw-pb-5 text-dark tw-cursor-pointer" onClick={this.props.onRequestPasswordReset} title="Esqueceu sua senha?">
                    <u>Esqueceu sua senha?</u>
                </Button>
                <FirebaseAuth page="signin" />
            </section>
        );
    }
}

LoginComponent.propTypes = exact({
    login: PropTypes.func.isRequired,
    firebasePopupOpen: PropTypes.bool.isRequired,
    onRequestPasswordReset: PropTypes.func.isRequired,
    submitting: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]).isRequired,
});

export default LoginComponent;
